"use client";

import { Radio } from "@base-ui-components/react/radio";
import { RadioGroup } from "@base-ui-components/react/radio-group";
import { classed, clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import type { InputProps } from "@/components/ui/Input";
import styles from "./Radio.module.css";

export interface RadioProps extends InputProps {}

// export const Radio = ({ id: initialId, className, ...props }: RadioProps) => {
// 	const internalId = useId();
// 	const id = initialId ?? internalId;

// 	return (
// 		<label htmlFor={id} className={clsx(styles.root, className)}>
// 			<input className={styles.radio} type="radio" id={id} {...props} />
// 		</label>
// 	);
// };

const RadioComponent = (props: ComponentProps<typeof Radio.Root>) => {
	return (
		<Radio.Root className={styles.radio} {...props}>
			<Radio.Indicator className={styles.indicator} />
		</Radio.Root>
	);
};

const RadioButton = ({
	children,
	className,
	...props
}: ComponentProps<typeof Radio.Root>) => {
	return (
		<label
			className={clsx(
				styles.radioButton,
				typeof className === "string" ? className : "",
			)}
		>
			<Radio.Root className={styles.radio} {...props}>
				<Radio.Indicator className={styles.indicator} />
			</Radio.Root>
			{children}
		</label>
	);
};

const ClassedRadioGroup = classed(RadioGroup, styles.radioGroup);

export {
	ClassedRadioGroup as RadioGroup,
	RadioButton,
	RadioComponent as Radio,
};
